/**
 * @generated SignedSource<<0639a07ba0a2de16d9794ffefe7e8bb0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getTermURL$data = {
  readonly refundTerms: ReadonlyArray<{
    readonly termsKey: string;
    readonly url: string;
  }>;
  readonly " $fragmentType": "getTermURL";
};
export type getTermURL$key = {
  readonly " $data"?: getTermURL$data;
  readonly " $fragmentSpreads": FragmentRefs<"getTermURL">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getTermURL"
};

(node as any).hash = "4871392ce16bc5015c1c30925f7d5e80";

export default node;
